import { useEffect } from "react";

import { Outlet, useNavigate } from "react-router-dom";

import { useMyProfile } from "shared/api/useMyProfile";
import { alertDialog } from "shared/ui/feedback";

/**
 * 최소 권한 등급(minAuth) 이상만 허용하는 경로 가드.
 * 권한 미달인 사용자가 URL로 직접 진입하면 안내 후 홈으로 되돌린다.
 * 권한이 확정되기 전(로딩)에는 아무것도 렌더하지 않아(fail-closed) 순간 노출을 막는다.
 * (실제 권한 검증은 서버가 담당하며, 이 가드는 UI·실수 방지 계층이다.)
 */
function RequireAuth({ minAuth, message = "접근 권한이 없습니다." }) {
  const navigate = useNavigate();
  const { data, isLoading } = useMyProfile();
  const allowed = (data?.auth ?? 0) >= minAuth;

  useEffect(() => {
    if (!isLoading && !allowed) {
      alertDialog(message);
      navigate("/", { replace: true });
    }
  }, [isLoading, allowed, message, navigate]);

  if (isLoading || !allowed) return null;
  return <Outlet />;
}

export default RequireAuth;
